// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-wrapper .graph-name {
    text-align: end;
    margin: 0 18px 12px;

    font-size: 17px;
    font-weight: 700;
    line-height: 22px;
    color: var(--dark-gray);
}

.graph-wrapper .graph-logo {
    padding: 0 15.5px;
    position: relative;
}

.graph-wrapper .graph-logo :is(.current-weight, .intermediate-weight, .goal-weight) {
    position: absolute;
    background-color: #8A8A8E;
    padding: 6px 8px;
    border-radius: 6px;

    opacity: 1;
    transform: translateY(-20%);

    font-size: 12.05px;
    font-weight: 700;
    line-height: 14.58px;
    color: var(--white);
    text-align: center;
}

.graph-wrapper .graph-logo > :is(.current-weight, .intermediate-weight, .goal-weight)::after {
    content: "";
    position: absolute;
    bottom: -5px;
    transform: translateX(-50%);
    border-width: 6px 6px 0;
    border-radius: 2px;
    border-color: #8A8A8E transparent transparent transparent;
}

.graph-wrapper .graph-logo .current-weight {
    left: 15px;
    top: -35px;
}

.graph-wrapper .graph-logo .current-weight:after {
    left: 30%;
}

.graph-wrapper .graph-logo .intermediate-weight {
    bottom: 115px;
    left: 130px;
}

.graph-wrapper .graph-logo .intermediate-weight::after {
    left: 25%;
}

.graph-wrapper .graph-logo .goal-weight {
    right: 14px;
    bottom: 65px;
    background-color: #606064;
}

.graph-wrapper .graph-logo .goal-weight::after {
    right: 0;
    border-color: #606064 transparent transparent transparent;
}

.graph-wrapper .graph-logo .img-wrapper {
    max-width: fit-content;
    overflow: hidden;
}

.graph-wrapper .graph-logo .img-wrapper img {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    min-height: 171px;
    min-width: 272px;
}

.graph-wrapper .periods {
    margin: 12px 7px auto;
    display: flex;
    justify-content: space-between;
}

.graph-wrapper .periods .label {
    font-size: 9px;
    font-weight: 700;
    line-height: 11px;
    text-transform: uppercase;
    color: var(--medium-gray);
}
#content.ja .graph-wrapper .periods .label,
#content.hu .graph-wrapper .periods .label,
#content.ro .graph-wrapper .periods .label {
    display: flex;
    flex-direction: row-reverse;
}
#content.ja .graph-wrapper .periods .label span.space{
    display: none;
}

.graph-wrapper .description-plan {
    margin-top: 24px;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--dark-gray);
}

`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.weight-loss-timeline-chart.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;;IAElB,UAAU;IACV,2BAA2B;;IAE3B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,QAAQ;IACR,yDAAyD;AAC7D;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;;;IAGI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B","sourcesContent":[".graph-wrapper .graph-name {\n    text-align: end;\n    margin: 0 18px 12px;\n\n    font-size: 17px;\n    font-weight: 700;\n    line-height: 22px;\n    color: var(--dark-gray);\n}\n\n.graph-wrapper .graph-logo {\n    padding: 0 15.5px;\n    position: relative;\n}\n\n.graph-wrapper .graph-logo :is(.current-weight, .intermediate-weight, .goal-weight) {\n    position: absolute;\n    background-color: #8A8A8E;\n    padding: 6px 8px;\n    border-radius: 6px;\n\n    opacity: 1;\n    transform: translateY(-20%);\n\n    font-size: 12.05px;\n    font-weight: 700;\n    line-height: 14.58px;\n    color: var(--white);\n    text-align: center;\n}\n\n.graph-wrapper .graph-logo > :is(.current-weight, .intermediate-weight, .goal-weight)::after {\n    content: \"\";\n    position: absolute;\n    bottom: -5px;\n    transform: translateX(-50%);\n    border-width: 6px 6px 0;\n    border-radius: 2px;\n    border-color: #8A8A8E transparent transparent transparent;\n}\n\n.graph-wrapper .graph-logo .current-weight {\n    left: 15px;\n    top: -35px;\n}\n\n.graph-wrapper .graph-logo .current-weight:after {\n    left: 30%;\n}\n\n.graph-wrapper .graph-logo .intermediate-weight {\n    bottom: 115px;\n    left: 130px;\n}\n\n.graph-wrapper .graph-logo .intermediate-weight::after {\n    left: 25%;\n}\n\n.graph-wrapper .graph-logo .goal-weight {\n    right: 14px;\n    bottom: 65px;\n    background-color: #606064;\n}\n\n.graph-wrapper .graph-logo .goal-weight::after {\n    right: 0;\n    border-color: #606064 transparent transparent transparent;\n}\n\n.graph-wrapper .graph-logo .img-wrapper {\n    max-width: fit-content;\n    overflow: hidden;\n}\n\n.graph-wrapper .graph-logo .img-wrapper img {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    display: block;\n    min-height: 171px;\n    min-width: 272px;\n}\n\n.graph-wrapper .periods {\n    margin: 12px 7px auto;\n    display: flex;\n    justify-content: space-between;\n}\n\n.graph-wrapper .periods .label {\n    font-size: 9px;\n    font-weight: 700;\n    line-height: 11px;\n    text-transform: uppercase;\n    color: var(--medium-gray);\n}\n#content.ja .graph-wrapper .periods .label,\n#content.hu .graph-wrapper .periods .label,\n#content.ro .graph-wrapper .periods .label {\n    display: flex;\n    flex-direction: row-reverse;\n}\n#content.ja .graph-wrapper .periods .label span.space{\n    display: none;\n}\n\n.graph-wrapper .description-plan {\n    margin-top: 24px;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    color: var(--dark-gray);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
